export const pointFactStartDate = (point = {}) =>
    point.enteredAtByLogist ||
    point.autoEnteredAt ||
    point.manualEstimatedLeaveDate ||
    point.estimatedDate ||
    point.estimatedLeaveDate;

export const pointFactEndDate = (point = {}) =>
    point.loadUnloadedAtByLogist ||
    point.autoLeftAt ||
    point.manualEstimatedLeaveDate ||
    point.enteredAtByLogist ||
    point.autoEnteredAt ||
    point.estimatedLeaveDate ||
    point.estimatedDate;
